const types = {
  GET_WIZARD_START: 'GET_WIZARD_START',
  GET_WIZARD_SUCCESS: 'GET_WIZARD_SUCCESS',
  GET_WIZARD_FAILURE: 'GET_WIZARD_FAILURE',
  GET_WIZARD_STEPS_SUCCESS: 'GET_WIZARD_STEPS_SUCCESS',
  GET_WIZARD_STEPS_START: 'GET_WIZARD_STEPS_START',
  GET_WIZARD_STEPS_FAILURE: 'GET_WIZARD_STEPS_FAILURE',
};
export default types;
